import immutableUpdate from 'immutable-update'
import utils from './utils'
import { 
  fetch 
} from 'data/controls'

export const initialstate = {
  current: false,
  isslider: false,
  domslides: null,
  blocksbyid: null,
  blockslides: null,
  datatree: null,
  actualSlide: 0
}

export const reducer = (state, action) => {

  switch(action.type) {

    case 'EVENT':

      return immutableUpdate(
        state,
        {
          blocksbyid: {
            [action.payload.blockid]: {
              lastevent: action.payload.event,
              ...action.payload.data
            }
          }
        }
      )

    case 'UPDATE':

      const blocktree = immutableUpdate(
        [],
        state.datatree
      )
      const newblocktree = utils.updatedtree(state, blocktree)

      return immutableUpdate(
        state,
        {
          datatree: newblocktree
        }
      )

    case 'UPDATESLIDES':

      if(state.domslides) {
      
        for(let item of state.domslides) {  

          item.className = item.className.replace('visible', '')
        }

        state.domslides.item(state.actualSlide).className += ' visible'
      }

      const evaluatedsliders = utils.updateblockslides(state.datatree)
      
      return immutableUpdate(
        state,
        {
          blockslides: evaluatedsliders
        }
      )

    case 'SAVESTATE':

      fetch(`/game/${state.gameid}/${state.userid}/${state.eventid}/instances/active/data`, {
        method: 'PUT',
        body: {
          progress: (state.actualSlide + 1) / state.blockslides.length,
          data: state.datatree
        }
      })
      
      return state

    default:   

      return immutableUpdate(
        state,
        action
      )
  } 
}